<div class="offline-notification-wrapper" *ngIf="showOfflineNotification">
  <div class="offline-notification mat-elevation-z8">
    <div class="offline-icon">
      <i class="material-icons">wifi_off</i>
    </div>
    <div class="offline-message">
      {{ 'pwa.offline_notification.message' | translate }}
    </div>
  </div>
</div>